<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-2">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-2">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-[#d9f9f9]">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-[#1f3341] uppercase tracking-wider"
                >
                  Case#
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-[#1f3341] uppercase tracking-wider"
                >
                  Member
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-[#1f3341] uppercase tracking-wider"
                >
                  Subject/Legal Matter
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-[#1f3341] uppercase tracking-wider"
                >
                  Created
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-[#1f3341] uppercase tracking-wider"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(item, i) in data" :key="i">
                <template v-if="i < 10">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-left">
                      <div class="ml-4">
                        <div class="text-sm font-medium text-gray-900">
                          {{ item?.number }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left"
                  >
                    {{ item?.member_name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <div class="text-sm text-gray-900">{{ item?.subject }}</div>
                    <div class="text-sm text-gray-500">
                      {{ item?.coverage }}
                    </div>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left"
                  >
                    {{ setDateFormat(item?.created_date) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <span
                      v-if="item?.status == 'New'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="item?.status == 'Open'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="item?.status == 'Completed'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                  </td>
                </template>
              </tr>
              <tr v-if="data?.length <= 0">
                <td class="text-center p-3" colspan="6">
                  No Records Found
                </td>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants.ts"; // importing constant resubale variables.
export default {
  name: "List",
  data() {
    return {
      setDateFormat: Constants.setDateFormat,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  created() {},
  methods: {},
};
</script>
